// extracted by mini-css-extract-plugin
export default {"headerBar":"ConfigDishonestPersonnel_headerBar__4s-dy","searcher":"ConfigDishonestPersonnel_searcher__U9r1-"};